<template>
  <div class="container-fluid p-3"> 
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">ANÁLISIS Y SEGUIMIENTO</h5>
        <div class="row mt-4">
          <div class="col-md-3"></div>
          <div class="col-md-6 input-group">
            <input
              type="text"
              class="form-control input-sm"
              placeholder="Nombres o Apellidos"
              v-model="parametro"
              @keypress="parametro = parametro.toUpperCase()"
              v-on:keyup.enter="AnalisisbusquedaPersona(1,parametro)" 
            
            />

            <div class="input-group-append">
              <button
                class="btn btn-info"
                type="button"
                @click="AnalisisbusquedaPersona(1,parametro)" 
              >
                Buscar <i class="fa fa-search"></i>
              </button>&nbsp;
              <button
              class="btn btn-warning"
              type="button"
              @click="Limpieza()"
            >
              Limpiar <i class="fa fa-search"></i>
            </button>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div> <br>
        
       <div>
        <!-- <div v-if="parametro !=''"> -->
        <div class="text-center" v-if="valida_mensaje==true"><h6><b>NO PRESENTA DECLARACIÓN</b></h6></div>
      <!-- </div> -->
        <b-card no-body >
          <b-tabs pills card >
            <b-tab :title="tituloDeclaracion" v-if="registrosDeclarados"><b-card-text>         
            <div class="col-md-3">            
              <a @click="exportarXls(parametro)" class="btn btn-success">Descargar<i class="fa fa-download"></i></a>   
            </div> 
            <div class="row">
              <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
                <table class="table table-bordered">
                  <tr class="text-center">
                    <th><small class="font-weight-bold">#</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">FECHA NACIMIENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>
                  <tr v-for="(item, index) in registrosEncontrados" :key="index">
                    <td class="text-center">
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td>
                      <small>{{ item.per_nombres + " " }}</small>
                      <small>{{ item.per_primer_apellido + " " }}</small>
                      <small v-if="item.per_segundo_apellido">{{item.per_segundo_apellido}}</small>
                    </td>
                    <td>
                      <small>
                        {{ item.per_numero_documento }} <br />
                        {{ item.tipo_documento }}
                      </small>
                    </td>
                    <td><small v-if="getDate(item.per_fecha_nacimiento)!='1900-01-01'">{{formatFecha(getDate(item.per_fecha_nacimiento))}}</small></td>
                    <td>
                      <small>{{ item.nombre }}</small>
                    </td>
                    <td><small>{{ item.fecha_reg}}</small></td>
                    <td class="text-center">
                      <router-link :to="{ name: 'mapeo', params: { id: item.id_persona } }" class="btn btn-outline-info btn-sm mr-1">
                        <i class="fa fa-eye"></i>
                      </router-link>
                      <router-link :to="{ name: 'DetalleDeclaracion', params: { id: item.id_persona } }" class="btn btn-outline-secondary btn-sm mr-1">
                        <i class="fa fa-list"></i>
                      </router-link>
                      <a
                        class="btn btn-outline-primary btn-sm mr-2"
                        title="Descargar"
                        :href="url+item.id_persona">
                        <i class="fa fa-file"></i>
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

        </b-card-text></b-tab>
          <b-tab :title="tituloHotel" v-if="registrosHotel!=''" ><b-card-text>
          <div class="col-md-3">
          <a @click="exportarHotelXls(parametro)" 
          class="btn btn-success">Descargar  <i class="fa fa-download"></i></a>   
          </div> 
          <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">PARTRES DE FECHA</small></th>
                <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                <th><small class="font-weight-bold">PROCEDENCIA</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosHotel" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                  <small>
                    {{ item.nro_documento }} </small><br>
                    <small v-if="getDate(item.fecha_nacimiento)!='1900-01-01'">{{"Fecha Nac: "+ formatFecha(getDate(item.fecha_nacimiento))}}</small>
                  
                </td>
                <td><small>{{item.nacionalidad}}</small><br><small>{{"Profesión: "+ item.profesion}}</small></td>
                  
                <td>
                  <small>{{"DE: "+ formatFecha(getDate(item.fecha_inicio))}}</small><br>
                  <small>{{"AL: "+ formatFecha(getDate(item.fecha_fin))}}</small>
                </td>
                <td>
                  <small>{{item.emp_razon_social}}</small>
                  <br>
                  <small>{{"Tipo: "+ item.tipo_detalle}}</small>
                  <br>
                  <small>{{"N. pieza: "+ item.nro_pieza}}</small>
                </td>
               <td>
                  <small>{{item.procedencia}}</small>
                  <br>
                  <small>{{"F. Ingreso: "+ formatFecha(getDate(item.fecha_ingreso))}}</small>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                <td class="text-center">
                 <small>{{item.fecha_reg}}</small>
                </td>
              </tr>
            </table>
          </div>
        </div>
        </b-card-text></b-tab>
            <b-tab v-if="registrosAviacion" :title="tituloAereo">
            <div class="col-md-3">
          
          <a @click="exportarAereoXls(parametro)" 
          class="btn btn-success">Descargar <i class="fa fa-download"></i></a>   
          </div> 
                <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">EMPRESA</small></th>
                <th><small class="font-weight-bold">DESCRIPCIÓN</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosAereo" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                  <small>
                    {{"Nro Doc: "+  item.nro_documento }} </small><br>
                    <small v-if="getDate(item.fecha_nacimiento)!='1900-01-01'">{{"Fecha Nac: "+ formatFecha(getDate(item.fecha_nacimiento))}}</small>
                </td>
                <td><small>{{item.nacionalidad}}</small></td>
                <td>
                  <small>{{ item.emp_razon_social }}</small>
                </td>
                <td>
                  <small>{{"Nro vuelo: "+ item.nro_vuelo }}</small> <br><small>{{" Tipo: "+  item.tipo_vuelo }}</small><br>
                  <small>{{"Origen: "+  item.origen }}</small><br><small>{{" Destino: "+  item.destino }}</small>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                <td><small>{{item.fecha_reg}}</small></td>
              </tr>
            </table>
          </div>
        </div>
        </b-tab>
      <b-tab :title="tituloTerrestre" v-if="registrosTerrestre">
            <div class="col-md-3">
          
          <a @click="exportarTerrestreXls(parametro)" 
          class="btn btn-success">Descargar <i class="fa fa-download"></i></a>   
          </div>
              <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                <th><small class="font-weight-bold">DESCRIPCIÓN</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosTerrestre" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                  <small>{{ item.nro_documento }}</small><br>
                  <small v-if="getDate(item.fecha_nacimiento)!='1900-01-01'">{{"fecha Nac:"+formatFecha(getDate(item.fecha_nacimiento))}}</small>

                </td>
                <td>
                  <small>{{item.nacionalidad }}</small>
                </td>
                <td><small>{{"Origen:"+item.origen}}</small><br>
                    <small>{{"Destino:"+item.destino}}</small> </td>
                
                <td>
                  <small>{{"F.Viaje:"+getDate(item.fecha_viaje) }}</small><br>
                  <small>{{"Placa: "+item.placa}}</small><br>
                  <small>{{"Nro de Bus: "+item.numero_bus}}</small>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                <td class="text-center">
                  <small>{{item.fecha_reg}}</small>
                </td>
              </tr>
            </table>
          </div>
        </div>
            </b-tab>
            <b-tab :title="tituloTurismo" v-if="registrosTurismo">
            <div class="col-md-3">
          <a @click="exportarTurismoXls(parametro)" 
          class="btn btn-success">Descargar <i class="fa fa-download"></i></a>   
          </div>
              <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                <th><small class="font-weight-bold">FECHA SERVICIO</small></th>
                <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosTurismo" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                  <small>
                    {{ "Nro Doc:"+item.nro_documento }}</small><br>
                    <small>{{"Fecha Nac:"+formatFecha(getDate(item.fecha_nacimiento))}}</small>
                </td>
                <td><small>{{item.nacionalidad}}</small></td>
                <td>
                  <small>{{ item.emp_razon_social }}</small>
                </td>
                <td><small>{{"Inicio:"+item.fecha_inicio}}</small><br>
                    <small>{{"Fin:"+item.fecha_fin}}</small>
                </td>
                <td><small>{{"Origen:"+item.origen}}</small><br>
                    <small>{{"Destino:"+item.destino}}</small>
                </td>
                <td><small>{{item.fecha_reg}}</small>
                </td>
              </tr>
            </table>
          </div>
        </div>
            </b-tab>
            <b-tab :title="tituloEducativa" v-if="registrosEstudiante!=''">
            <div class="col-md-3">
          <a @click="exportarEducativasXls(parametro)" 
          class="btn btn-success">Descargar <i class="fa fa-download"></i></a>   
          </div>
                 <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">RAZÓN SOCIAL</small></th>
                <th><small class="font-weight-bold">CARRERA</small></th>
                <th><small class="font-weight-bold">FECHA INSCRIPCIÓN</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosEducativa" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                 <small>
                    {{ "Nro Doc:"+item.nro_documento }}</small><br>
                    <small>{{"Fecha Nac:"+formatFecha(getDate(item.fecha_nacimiento))}}</small>
                </td>
                <td><small>{{item.nacionalidad}}</small></td>
                
                <td><small>{{item.emp_razon_social}}</small></td>
                <td>
                  <small>{{ item.carrera}}</small><br>
                    <small>{{"Ciclo Acad:"+item.observacion}}</small>
                </td>
                <td>
                  <small>{{ formatFecha(getDate(item.fecha_inscripcion))}}</small><br>
                </td>
                <td>
                  <small>{{item.fecha_reg}}</small><br>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                
              </tr>
            </table>
          </div>
        </div>
            </b-tab>
            <b-tab :title="tituloNocturna" v-if="registrosNocturno">
            <div class="col-md-3">
          <a @click="exportarNocturnoXls(parametro)" 
          class="btn btn-success">Descargar<i class="fa fa-download"></i></a>   
          </div>
                <div class="row">
          <div class="table-responsive mt-3" style="overflow-y:scroll; height:400px;">
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                <th><small class="font-weight-bold">FECHAS</small></th>
                <th><small class="font-weight-bold">FECHA REGISTRO</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontradosNocturna" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.nombres + " " }}</small>
                  <small>{{ item.apellidos + " " }}</small>
                  
                </td>
                <td>
                  <small>
                    {{ "Nro Doc:"+item.nro_documento }}</small><br>
                    <small>{{"Fecha Nac:"+formatFecha(getDate(item.fecha_nacimiento))}}</small>
                </td>
                <td><small>{{item.nacionalidad}}</small></td>
                <td>
                  <small>{{"Fecha Inicio:"+formatFecha(getDate(item.fecha_inicio))}}</small><br>
                    <small>{{"Fecha Fin:"+formatFecha(getDate(item.fecha_fin))}}</small>
                </td>
                <!-- <td><small>{{ item.direccion }}</small></td> -->
                <td class="text-center">
                  <small>{{item.fecha_reg}}</small>
                </td>
              </tr>
            </table>
          </div>
        </div> 
          </b-tab>
          </b-tabs>
        </b-card>
      </div>

        
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import moment from "moment";

export default {
  name: "buscarExtranjero",
  components: {
    Loading,
  },
  data() {
    return {
      parametro: '',
      registrosEncontrados: [],
      registrosEncontradosHotel: [],
      registrosEncontradosAereo: [],
      registrosEncontradosTerrestre: [],
      registrosEncontradosTurismo: [],
      registrosEncontradosEducativa: [],
      registrosEncontradosNocturna: [],
      url: process.env.VUE_APP_URL + '/documento/3/',
      cargando: false,
      valida_mensaje: false,
      registrosDeclarados: false,
      registrosHotel: false,
      registrosAviacion: false,
      registrosTerrestre: false,
      registrosTurismo: false,
      registrosEstudiante: false,
      registrosNocturno: false,
      tituloDeclaracion:'',
      tituloHotel:'',
      tituloAereo:'',
      tituloTerrestre:'',
      tituloTurismo:'',
      tituloEducativa:'',
      tituloNocturna:'',
    };
  },
  methods: {  
    async AnalisisbusquedaPersona(a,parametro) {
     this.Limpiar();
      try { 
                       
        if(a==1){ 
          
          let resultados = await this.axios.get(`/personaBuscar/${parametro}`);
          
          this.registrosEncontrados = resultados.data.contenido;
          if(this.registrosEncontrados.length > 0 ){
            this.registrosDeclarados =true;
            
            this.tituloDeclaracion = `Declaraciones de Domicilio (${this.registrosEncontrados.length})`;
          }
        }
        if(a==1){
         
          let resultados = await this.axios.get(`/hotelBuscar/${parametro}`);
          this.registrosEncontradosHotel = resultados.data.contenido; 
         
          if(this.registrosEncontradosHotel.length > 0){
            this.registrosHotel =true;
           
            this.tituloHotel = `Centro de Hospedaje (${this.registrosEncontradosHotel.length})`;
           
          }
        }
        if(a==1){
          let resultados = await this.axios.get(`/aereoBuscar/${parametro}`);
          this.registrosEncontradosAereo = resultados.data.contenido;
          if(this.registrosEncontradosAereo.length > 0 || this.registrosEncontradosAereo!=''){
            this.registrosAviacion =true;
            this.tituloAereo = `Transporte Aereo (${this.registrosEncontradosAereo.length})`;
          }
        }
        if(a==1){
          let resultados = await this.axios.get(`/terrestreBuscar/${parametro}`);
          this.registrosEncontradosTerrestre = resultados.data.contenido;
          if(this.registrosEncontradosTerrestre.length > 0){
            this.registrosTerrestre =true;            
            this.tituloTerrestre = `Transporte Terrestre (${this.registrosEncontradosTerrestre.length})`;
          }
        }
        if(a==1){
          let resultados = await this.axios.get(`/turismoBuscar/${parametro}`);
         
          this.registrosEncontradosTurismo = resultados.data.contenido;
          if(this.registrosEncontradosTurismo.length > 0){
            this.registrosTurismo =true;
            this.tituloTurismo = `Transporte Turismo (${this.registrosEncontradosTurismo.length})`;
          }
        }
        if(a==1){
          let resultados = await this.axios.get(`/educativaBuscar/${parametro}`);
          this.registrosEncontradosEducativa = resultados.data.contenido;
          if(this.registrosEncontradosEducativa.length > 0){
            this.registrosEstudiante =true;
            this.tituloEducativa = `Entidades Eductivas (${this.registrosEncontradosEducativa.length})`;
          }
        }
        if(a==1){
          let resultados = await this.axios.get(`/nocturnaBuscar/${parametro}`);
          
          this.registrosEncontradosNocturna = resultados.data.contenido;
          if(this.registrosEncontradosNocturna.length > 0){
            this.registrosNocturno =true;
            this.tituloNocturna = `Clubes Nocturnos (${this.registrosEncontradosNocturna.length})`;
          }
        } 
        if( this.registrosHotel== false &&
            this.registrosDeclarados== false &&
              this.registrosHotel== false &&
              this.registrosAviacion== false &&
              this.registrosTerrestre== false &&
              this.registrosTurismo== false &&
              this.registrosEstudiante== false &&
              this.registrosNocturno==false ){
          this.valida_mensaje=true;
        }        
      }

      catch (error) {
        console.log('catch: ', error);
      }
    },
    Limpiar() {
     this.registrosHotel="",
     this.registrosDeclarados="",
      this.registrosHotel="",
      this.registrosAviacion="",
      this.registrosTerrestre="",
      this.registrosTurismo="",
      this.registrosEstudiante="",
      this.registrosNocturno="" 
    },
    Limpieza(){
      this.parametro= '',
      this.registrosEncontrados= [],
      this.registrosEncontradosHotel= [],
      this.registrosEncontradosAereo= [],
      this.registrosEncontradosTerrestre= [],
      this.registrosEncontradosTurismo= [],
      this.registrosEncontradosEducativa= [],
      this.registrosEncontradosNocturna= [],
      this.cargando= false,
      this.valida_mensaje= false,
      this.registrosDeclarados= false,
      this.registrosHotel= false,
      this.registrosAviacion= false,
      this.registrosTerrestre= false,
      this.registrosTurismo= false,
      this.registrosEstudiante= false,
      this.registrosNocturno= false,
      this.tituloDeclaracion='',
      this.tituloHotel='',
      this.tituloAereo='',
      this.tituloTerrestre='',
      this.tituloTurismo='',
      this.tituloEducativa='',
      this.tituloNocturna=''
    },
     async exportarXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaAnalistaExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async exportarHotelXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaHotelExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },

    async exportarAereoXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaAereoExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async exportarTerrestreXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaTerrestreExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async exportarTurismoXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaTurismoExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    async exportarEducativasXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaEducativaExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
        async exportarNocturnoXls(parametro){
     let config = { headers: {token: this.token}, responseType: 'blob'};
      this.cargando= true;
      try {
        let resultados = await this.axios.get(`/busquedaNocturnoExcel/${parametro}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');

        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
  },
  created() {},
};
</script>
